const Route = (() => {
    /**
     * @param {Object} props - The props
     * @param {string | undefined} [props.clientId]  client tenant ID
     * @param {string | undefined} [props.partnerId] partner tenant ID
     * @returns {string} constructed base path
     */
    const buildBaseRoute = ({
        clientId = null,
        partnerId = null
    }: {
        clientId?: string | null;
        partnerId?: string | null;
    }): string => {
        if (clientId || partnerId) {
            return `${partnerId ? `/partner/${partnerId}` : ''}${
                clientId ? `/admin/${clientId}` : ''
            }`;
        }
        return '/';
    };

    /**
     * @param {Object} props - The props
     * @param {string} props.clientId  client tenant ID
     * @param {string | undefined} [props.partnerId] (optional)  partner tenant ID
     * @returns {string} constructed admin path
     */
    const buildBaseAdminRoute = ({
        clientId,
        partnerId = null
    }: {
        clientId: string;
        partnerId?: string | null;
    }): string =>
        `${partnerId ? `/partner/${partnerId}` : ''}/admin/${clientId}`;

    /**
     *
     * @param {Object} props - The props
     * @param {string} props.partnerId partner tenant ID
     * @returns {string} constructed partner path
     */
    const buildBasePartnerRoute = ({
        partnerId
    }: {
        partnerId: string;
    }): string => `/partner/${partnerId}`;

    /**
     *
     * @param {Object} props - The props
     * @param {string} [props.clientId]   client tenant ID
     * @param {string} [props.partnerId]  partner tenant ID
     * @returns {string} constructed reports path
     */
    // We have this function duplicated in cron for the scheduledReports cron.
    // If this function changes, please update cron as well.
    const buildBaseReportsRoute = ({
        partnerId,
        clientId
    }: {
        clientId?: string;
        partnerId?: string;
    }): string => {
        if (partnerId && clientId) {
            return `/partner/${partnerId}/admin/${clientId}/reports`;
        }

        if (partnerId) {
            return `/partner/${partnerId}/reports`;
        }

        if (clientId) {
            return `/admin/${clientId}/reports`;
        }

        // Will this ever happen???
        // Do we have links on pages that don't have either a partnerId or clientId in the URL?
        return '';
    };

    return {
        buildBaseAdminRoute,
        buildBasePartnerRoute,
        buildBaseReportsRoute,
        buildBaseRoute
    };
})();

export default Route;
